export default __webpack_public_path__ + "static/media/button_help.a6084eb2.png";